import { useState } from "react";
import { CheckCircle2, Smile, Users, Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

const options = [
  {
    id: "book",
    title: "Book Pulo",
    description: "Book Pulo assistants, accommodation and rides all in one touch",
    icon: Smile,
    accent: "border-2 border-[#b04b83] text-[#64013B]",
  },
  {
    id: "assistant",
    title: "Become a Pulo Assistant",
    description: "You know your city better? show tourist around and earn money with Pulo",
    icon: Users,
    accent: "border-2 border-[#b04b83] text-[#0f5a7a]",
  },
  {
    id: "host",
    title: "Become a Host",
    description: "Earn with Pulo by listing your apartment",
    icon: Building2,
    accent: "border-2 border-[#b04b83] text-[#0f5a7a]",
  },
];

export default function Welcome() {
  const [selectedOption, setSelectedOption] = useState("book");
  const navigate = useNavigate();

  const handleContinue = () => {
    if (selectedOption === "book") {
      navigate("/auth/register");
      return;
    }
    if (selectedOption === "assistant") {
      navigate("/auth/assistant-register");
      return;
    }

    navigate("/coming-soon", { state: { from: selectedOption } });
  };

  return (
    <div className="min-h-screen bg-white text-gray-900 px-4 py-12 flex items-center justify-center">
      <div className="w-full max-w-3xl">
        <div className="flex justify-center mb-10">
          <img src="/images/logo.png" className="w-20" alt="PULO logo" />
        </div>

        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold mb-3">Welcome to Pulo</h1>
          <p className="text-md text-gray-600 font-medium">How would you like to use Pulo?</p>
        </div>

        <div className="space-y-4 max-w-xl mx-auto">
          {options.map((option) => {
            const Icon = option.icon;
            const isActive = selectedOption === option.id;

            return (
              <button
                key={option.id}
                type="button"
                onClick={() => setSelectedOption(option.id)}
                className={`w-full rounded-xl border px-5 py-4 text-left transition shadow-sm flex  gap-4 ${
                  isActive
                    ? `${option.accent} `
                    : "border-gray-200 bg-white hover:border-gray-300"
                }`}
              >
                <span
                  className={`inline-flex h-10 w-10 items-center justify-center ${
                    isActive ? "h-7 text-[#b04b83]": " text-gray-600"
                  } bg-white`}
                >
                  <Icon className="h-5 w-5" />
                </span>

                <div className="flex-1">
                  <p className="text-lg font-semibold text-gray-800">{option.title}</p>
                  <p className="text-sm text-gray-600 font-medium mt-1">{option.description}</p>
                </div>

                <span
                  className={`flex h-5 w-5 items-center justify-center rounded-full border-2 ${
                    isActive ? "border-[#64013B] bg-[#64013B] text-white" : "border-gray-300"
                  }`}
                  aria-hidden
                >
                  {isActive && <CheckCircle2 className="h-4 w-4" />}
                </span>
              </button>
            );
          })}
        </div>

        <div className="max-w-xl mx-auto mt-8">
          <button
            type="button"
            onClick={handleContinue}
            className="w-full rounded-lg bg-[#64013B] py-3 text-xl font-medium text-white shadow-md transition hover:bg-[#7a0051] focus:outline-none focus:ring-2 focus:ring-[#7a0051]/60 focus:ring-offset-2"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
